import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../config.axios";
import { toggleLoading } from "../LoadingSlice";
import { toast } from "react-toastify";

export interface InspectionSettingData {
    inspection_schedule_flow: string;
    warehouse_id: number;
}

interface InspectionSettingState {
    inspectionsetting: {
        load: boolean;
        data: Array<InspectionSettingData>;
    };
    inspectionSettingData?: InspectionSettingData;
}

const initialState = {
    inspectionsetting: {
        load: false,
        data: [],
    },
    inspectionSettingData: {
        inspection_schedule_flow: "",
        warehouse_id: 0,
    },
} as InspectionSettingState;

export const inspectionSettingSlice = createSlice({
    name: "inspectionsetting",
    initialState,
    reducers: {
        resetSettingData: (state: InspectionSettingState) => {
            state.inspectionSettingData = initialState.inspectionSettingData;
        },
        updateSettingData: (state: InspectionSettingState, action: { payload: InspectionSettingData }) => {
            state.inspectionSettingData = action.payload;
        },
    },
});

export const { resetSettingData, updateSettingData } = inspectionSettingSlice.actions;

export default inspectionSettingSlice.reducer;


export const InspectionSetting = createAsyncThunk(
    "inspectionsetting/InspectionSetting",
    async (param: { apiParam : {inspection_schedule_flow: any, warehouse_id: any}}, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());

            const { data } = await DataServer.post(`api/postInspectionSetting`, {
                warehouse_id: param.apiParam.warehouse_id,
                inspection_schedule_flow: param.apiParam.inspection_schedule_flow
            });

            thunkAPI.dispatch(toggleLoading());
            toast.success(data.message,{theme: "colored"});

        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    });



export const ReportTpiIssue = createAsyncThunk(
    "reportissue/ReportIssue",
    async (param: any, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const warehouse_id = localStorage.getItem("_warehouse_id");

            const { data } = await DataServer.post(`api/tpiReportedIssueVerify/${param.apiParam.id}`,
                param.apiParam.reportIssueData,
            );

            thunkAPI.dispatch(toggleLoading());

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/inspection-details");
            };
            thunkAPI.dispatch(toggleLoading());

        } catch (error) {
            toast.error("Something went wrong!",{theme: "colored"});
            thunkAPI.dispatch(toggleLoading());
        }
    });